<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
      <div class="navbar-brand">Automated Rules</div>
      <div class=" ms-auto">
          <a class="btn btn-sm btn-outline-primary" [routerLink]="['/lo', selected_company, 'setting-automated', 'form']">&#43; Add Automated Rule</a>
      </div>
    </div>
  </nav>
  <hr/>
  <app-tablev2 #table ></app-tablev2>
  